import { combineReducers } from "@reduxjs/toolkit";
import orgChartTreeSlice from "./orgChartTreeSlice";

export const orgChartReducer = combineReducers({

  orgChartTreeSlice
});

export default orgChartReducer;
